<mat-sidenav-container [ngClass]="!isLogged() ? 'sidenav-container-loggin' : 'sidenav-container'">
    <mat-sidenav #drawer class="sidenav" fixedInViewport="true"
                 [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
                 [mode]="(isHandset$ | async)   ? 'over' : 'side'"
                 [opened]="menuItems && menuItems.length > 0 && isLogged() && !(isHandset$ | async)">
        <app-sidenavHeader></app-sidenavHeader>
        <app-menu [items]="menuItems" (itemClicked$)="menuItemClicked(drawer)"></app-menu>
    </mat-sidenav>
    <mat-sidenav-content>
        <header>
            <app-header [drawer]="drawer" [menuAvailable]="menuItems && menuItems.length > 0"
                        [isHandset$]="isHandset$"></app-header>
        </header>
        <main [ngClass]="!isLogged() ? 'main-loggin' : 'main'">
            <router-outlet></router-outlet>
        </main>
        <footer>
            <app-footer *ngIf="isLogged()"></app-footer>
        </footer>
    </mat-sidenav-content>
</mat-sidenav-container>
<app-knowledge-sidenav *ngIf="isLogged()"></app-knowledge-sidenav>
<div class="cargando_overlay" *ngIf="mostrarCargando && cargando && isLogged()">
    <div>Cargando datos. Por favor, espere…</div>
</div>
